body > nav {
  z-index: 1;
  position: relative;
  margin: var(--sl-spacing-x-large) 0 var(--sl-spacing-large);
  font-weight: 520;
}

@media (max-width: 1023px) {

body > nav {
    margin: var(--sl-spacing-medium) 0;
}
  }

body > nav.edge {
    background: linear-gradient(
      to bottom,
      white 0%,
      rgb(255, 251, 235) 90%,
      white 100%
    );
  }

body > nav a[aria-current] {
    text-decoration-thickness: 5px;
    text-decoration-skip: none;
    text-underline-offset: 0.3em;
  }

body > nav .logo {
    width: 320px;
    margin-top: -45px;
  }

@media (max-width: 1023px) {

body > nav .logo {
      margin-top: -20px;
  }
    }

body > nav sl-button[menutoggle] {
    margin-top: -45px;
  }

body > nav kbd {
    position: absolute;
    margin-left: 0.7rem;
    font-size: 70%;
    font-weight: var(--body-font-weight);
    opacity: 0.5;
  }

html:not([loaded]) #nav-bar {
  opacity: 0;
  animation: fadeIn 1s 0.1s;
  animation-fill-mode: forwards;
}

navbar-inner,
footer-inner {
  display: block;
  max-width: var(--max-content-width);
  margin: 0 auto;
}

bridgetown-search-form input {
  display: block;
  appearance: none;
  font-family: inherit;
  font-size: 1em;
  font-weight: 520;
  margin-bottom: 0.3em;
  padding: 0.2em 0.6em;
  width: calc(100% - 1.3em);
  background: #fff;
  opacity: 0.5;
  border: 1px solid var(--color-light-gray);
  border-radius: 1em;
  box-shadow: inset 0 0.0625em 0.125em rgba(10, 10, 10, 0.05);
  color: inherit;
}

bridgetown-search-form input:focus,
  bridgetown-search-form input:hover {
    opacity: 1;
  }

@keyframes swingBackAndForth {
  0% {
    transform: rotate(-7deg);
  }
  4.5% {
    transform: rotate(-16deg);
  }
  11.5% {
    transform: rotate(-7deg);
  }
  18% {
    transform: rotate(-10deg);
  }
  25% {
    transform: rotate(-7deg);
  }
  30% {
    transform: rotate(-8deg);
  }
  37% {
    transform: rotate(-7deg);
  }
}

edge-label {
  position: absolute;
  left: 7.3rem;
  top: 4.5rem;
  margin: 0;
  font-size: 0.9rem;
  font-weight: bold;
  transform: rotate(-7deg);
  transform-origin: 99% 2%;
  background: var(--color-orange);
  color: white;
  padding: 0.25em 0.7em;
  border-radius: 4px 2px 4px 4px;
  box-shadow: 0px 11px 6px -7px rgba(0, 0, 0, 0.15);
  text-shadow: 0px 1px 1px rgba(0, 0, 0, 0.2);
  cursor: pointer;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);

  animation: swingBackAndForth 8s;
  animation-delay: 1s;
  animation-iteration-count: infinite;
  animation-timing-function: ease-in-out;
}

@media (max-width: 1023px) {

edge-label {
    font-size: 0.75rem;
    top: 5.15rem;
    left: 7.75rem;
}
  }

/*# sourceMappingURL=data:application/json;base64,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 */